import React, { useState, useEffect } from 'react';
import { Trash3, PencilSquare } from 'react-bootstrap-icons'
import Navbar from '../components/Navbar'
import { BASE_URL } from '../screen/helper'

export default function Register() {
  const [userdata, setUserData] = useState({
    name: '',
    email: '',
    mobileNumber: ''
  });

  const handleChange = (event) => {
    setUserData({ ...userdata, [event.target.name]: event.target.value });
  };
  const [getdata, setgetdata] = useState([]);
  const [updateUI, setUpdateUI] = useState(false);
  const [dataId, setDataId] = useState(null);
  const [editbtn, seteditbtn] = useState(false);
  const [search, setsearch] = useState("");

  const onChange = (e) => {
    setsearch(e.target.value)
    console.log(e.target.value);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/getuserdata`);
        const jsonData = await response.json();
        setgetdata(jsonData);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [updateUI]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`${BASE_URL}/api/createuser`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Content-Length': JSON.stringify({ name: userdata.name, email: userdata.email, mobileNumber: userdata.mobileNumber })
      },
      body: JSON.stringify({ name: userdata.name, email: userdata.email, mobileNumber: userdata.mobileNumber })
    });
    const json = await response.json()
    console.log(json);
    if (!json.success) {
      alert("Enter vailed user data")
    }
    if (json.success) {
      setUserData({
        name: '',
        email: '',
        mobileNumber: ''
      });
      setUpdateUI((prevState) => !prevState);
      // console.log(userdata);
    }
  }

  const UpdateSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(`${BASE_URL}/api/updateuser/${dataId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ name: userdata.name, email: userdata.email, mobileNumber: userdata.mobileNumber })
      });
      if (response.ok) {
        const json = await response.json();
        console.log(json);
        // alert("Your data is Updated");
        setUserData({
          name: '',
          email: '',
          mobileNumber: ''
        });
        seteditbtn(false)
        setUpdateUI((prevState) => !prevState);
      }
    } catch (error) {
      console.log("Error updating data:", error);
      alert("Failed to update data. Please try again.");
    }
  }

  const update = async (dataId) => {
    try {
      const response = await fetch(`${BASE_URL}/api/getuserdata/${dataId}`);
      const jsonData = await response.json();
      setUserData(jsonData);
      setDataId(dataId);
      seteditbtn(true);
    } catch (error) {
      console.log(error);
    }
  }

  const deleteUser = async (dataId) => {
    try {
      const response = await fetch(`${BASE_URL}/api/deleteuserdata/${dataId}`, {
        method: 'DELETE'
      });
      if (response.ok) {
        const json = await response.json();
        console.log(json);
        alert("Are you sure your data is Deleted");
        setUpdateUI((prevState) => !prevState);
      }
    } catch (error) {
      console.log("Error deleting data:", error);
      alert("Failed to delete data. Please try again.");
    }
  }

  return (
    <>
      <Navbar input=<input className="form-control me-5" type="search" value={search} onChange={onChange} placeholder="Search" aria-label="Search" /> />
      <div className="container">
        <div className="row input-row">
          <div className="col">
            <input type="text" className="form-control" placeholder="Name" name="name" value={userdata.name} onChange={handleChange} />
          </div>
          <div className="col">
            <input type="email" className="form-control" placeholder="Email" name="email" value={userdata.email} onChange={handleChange} />
          </div>
          <div className="col">
            <input type="text" className="form-control" placeholder="Mobile" name="mobileNumber" value={userdata.mobileNumber} onChange={handleChange} />
          </div>

          {editbtn ? (
            <button className="btn btn-primary add-btn" onClick={UpdateSubmit}>
              Update
            </button>
          ) : (
            <button className="btn btn-primary add-btn" onClick={handleSubmit}>
              Add
            </button>
          )}
        </div>
      </div>
      <table className=" container table t-class">
        <thead>
          <tr className="table-dark">
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            <th scope="col">MobileNumber</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {getdata.length === 0 ? (
            // Skeleton loading effect
            <tr>
              <td className='loading' colSpan="5">Loading...</td>
            </tr>
          ) :
            getdata.filter((data) => {
              if (search === "") {
                return true;
              } else if (data.name && data.name.toLowerCase().includes(search.toLowerCase())) {
                return true;
              }
              return false;
            }).map((data, id) => {
              return (
                <>
                  <tr key={data._id}>
                    <th scope="row">{id + 1}</th>
                    <td>{data.name}</td>
                    <td>{data.email}</td>
                    <td>{data.mobileNumber}</td>
                    <td className="d-flex justify-content-between action-btn">
                      <button className="update" onClick={() => update(data._id)}>
                        <PencilSquare />
                      </button>
                      <button className="delet" onClick={() => deleteUser(data._id)}>
                        <Trash3 />
                      </button>
                    </td>
                  </tr>
                </>
              );
            })}
        </tbody>
      </table>

    </>
  );
}  
